async function cartUpsellAdd(button) {
  const variantId = button.dataset.variantId;

  if (!variantId || variantId === 'undefined') {
    button.textContent = 'Unavailable';
    return;
  }

  button.textContent = '...';
  button.disabled = true;

  try {
    // Single call — add item AND get updated sections at the same time
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        id: parseInt(variantId), 
        quantity: 1,
        sections: 'cart-drawer'  // ← Dawn returns the re-rendered drawer in the SAME response
      })
    });

    const addData = await addRes.json();

    if (!addRes.ok) {
      throw new Error(addData.description || 'Failed to add item');
    }

    // Update shipping bar immediately from the response
    if (addData.sections && addData.sections['cart-drawer']) {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(addData.sections['cart-drawer'], 'text/html');
      const newInner = newDoc.querySelector('.cart-drawer');
      const oldInner = document.querySelector('cart-drawer .cart-drawer');
      if (newInner && oldInner) {
        oldInner.innerHTML = newInner.innerHTML;
      }
    }

    // Update shipping bar
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    updateShippingBar(cart.total_price);

    button.textContent = '✓ Added!';
    button.style.background = '#3a7d5c';

    setTimeout(() => {
      button.textContent = '+ Add';
      button.style.background = '';
      button.disabled = false;
    }, 1500);

  } catch (err) {
    console.error('Upsell add failed:', err);
    button.textContent = '+ Add';
    button.style.background = '';
    button.disabled = false;
  }
}

function updateShippingBar(totalCents) {
  const threshold = 20000;
  const pct = Math.min(100, (totalCents / threshold) * 100);
  const fill = document.querySelector('.progress-fill');
  const text = document.querySelector('.free-shipping-text');

  if (fill) fill.style.width = pct + '%';

  if (text) {
    if (totalCents >= threshold) {
      text.innerHTML = "🎉 You've unlocked <span>FREE shipping!</span>";
    } else {
      const remaining = ((threshold - totalCents) / 100).toFixed(2);
      text.innerHTML = `You're <span>$${remaining} away</span> from Free Shipping 🚚`;
    }
  }
}